module.exports = __webpack_public_path__ + "img/1.5f3f85c6.png";